import type FolderId from 'owa-service/lib/contract/FolderId';
import type {
    CalendarEntry,
    LocalCalendarEntry,
    LinkedCalendarEntry,
    LinkedCalendarEntryV2,
} from 'owa-graph-schema';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isLinkedCalendarEntryV2 } from './isLinkedCalendarEntryV2';
import { isBootFeatureEnabled } from 'owa-metatags';

export function getCalculatedFolderId(
    calendar: CalendarEntry | LocalCalendarEntry
): FolderId | null {
    // local calendar entry
    const localCalendarEntry: LocalCalendarEntry = calendar as LocalCalendarEntry;

    if (localCalendarEntry.FolderId) {
        return {
            Id: localCalendarEntry.FolderId.Id,
            ChangeKey:
                localCalendarEntry.FolderId.ChangeKey != null
                    ? localCalendarEntry.FolderId.ChangeKey
                    : '',
        };
    }

    if (
        isBootFeatureEnabled('cal-enable-HybridModel-for-calendarSharing') &&
        isLinkedCalendarEntryV2(calendar)
    ) {
        const linkedCalendarEntryV2: LinkedCalendarEntryV2 = calendar as LinkedCalendarEntryV2;
        if (linkedCalendarEntryV2.SharedFolderId) {
            return linkedCalendarEntryV2.SharedFolderId.Id
                ? {
                      Id: linkedCalendarEntryV2.SharedFolderId.Id,
                      ChangeKey:
                          linkedCalendarEntryV2.SharedFolderId.ChangeKey != null
                              ? linkedCalendarEntryV2.SharedFolderId.ChangeKey
                              : '',
                  }
                : null;
        }
    }

    const linkedCalendarEntry: LinkedCalendarEntry = calendar as LinkedCalendarEntry;

    if (isGlobalFeatureEnabled('cal-invoke-GCV-FreeBusyCalendars')) {
        if (linkedCalendarEntry.SharedFolderId) {
            return linkedCalendarEntry.SharedFolderId.Id
                ? {
                      Id: linkedCalendarEntry.SharedFolderId.Id,
                      ChangeKey:
                          linkedCalendarEntry.SharedFolderId.ChangeKey != null
                              ? linkedCalendarEntry.SharedFolderId.ChangeKey
                              : '',
                  }
                : null;
        }

        if (linkedCalendarEntry.IsGeneralScheduleCalendar) {
            return linkedCalendarEntry.OwnerEmailAddress
                ? { Id: linkedCalendarEntry.OwnerEmailAddress, ChangeKey: '' }
                : null;
        }
    } else {
        if (linkedCalendarEntry.IsGeneralScheduleCalendar) {
            return linkedCalendarEntry.OwnerEmailAddress
                ? { Id: linkedCalendarEntry.OwnerEmailAddress, ChangeKey: '' }
                : null;
        }
        if (linkedCalendarEntry.SharedFolderId) {
            return linkedCalendarEntry.SharedFolderId.Id
                ? {
                      Id: linkedCalendarEntry.SharedFolderId.Id,
                      ChangeKey:
                          linkedCalendarEntry.SharedFolderId.ChangeKey != null
                              ? linkedCalendarEntry.SharedFolderId.ChangeKey
                              : '',
                  }
                : null;
        }
    }
    return null;
}
